<p>
  ETC Bookings
</p>
<p-table [value]="bookings">
  <ng-template pTemplate="header">
    <tr>
      <th>
        ID
      </th>
      <th>
        Firstname
      </th>
      <th>
        Lastname
      </th>
      <th>
        Start
      </th>
      <th>
        End
      </th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-booking>
<tr routerLink="/management/edit-booking/{{booking.id}}">
  <td>
    {{booking.id}}
  </td>
  <td>
    {{booking.student.firstName}}
  </td>
  <td>
    {{booking.student.lastName}}
  </td>
  <td>
    {{booking.startDate | date: 'dd/MM/yyyy'}}
  </td>
  <td>
    {{booking.endDate | date: 'dd/MM/yyyy'}}
  </td>
</tr>
  </ng-template>
</p-table>